import React, {useState, useEffect} from 'react'
import Icon from 'components/utils/Icon'
import Modal from 'components/utils/Modal'

import SampleStatus from 'components/utils/SampleStatus'
import TestNotes from 'components/utils/TestNotes'
import SentOut from 'components/utils/SentOut'

import { formatDateTime, getLocation, nothingChanged, addActivity } from 'scripts/common'

const Passing200 = (props) => {

  const data = props.data[0]
  const [fetchedDescriptions, setFetchedDescriptions] = useState([])
  const [fetchedColors, setFetchedColors] = useState([])
  //const [isChangedSample, setIsChangedSample] = useState(false)

  const [isValidated, setIsValidated] = useState({
    moistureTaken: data.moistureTaken === 1 ? true : false,
    mcTareNo: data.mcTareNo,
    mcTareWt: data.mctarewt,
    wetSoilAndTareWt: data.wetsoilandtarewt,
    drySoilAndTareWt: data.drysoilandtarewt,
    tareNo: data.tareNo,
    tareWt: data.tarewt,
    totalWt: data.totalwt,
    retainWt: data.retainwt,
    status: data.status,
    notes: data.notes,
    sentOutCompany: data.sentOutCompany,
    sentOutDeliverDate: data.sentOutDeliverDate,
    sentOutReceiveDate: data.sentOutReceiveDate
  })

  const fetchData = () => {

    fetch('/api/selectDescription', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    })
    .then(res=>res.json())
    .then(
      (result) => {
        setFetchedDescriptions(result)
      },
      (error) => {
        console.log('error: ' + error)
      }
    )

    fetch('/api/selectColor', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    })
    .then(res=>res.json())
    .then(
      (result) => {
        setFetchedColors(result)
      },
      (error) => {
        console.log('error: ' + error)
      }
    )

  }

  useEffect(() => {
    fetchData()
  }, [])

  const validate = (event) => {
    let name = event.target.getAttribute('name')
    let state = event.target.reportValidity()
    let type = event.target.type
    let value = type === 'checkbox' ? event.target.checked : event.target.value

    event.target.style.backgroundColor = state ? 'white' : 'tomato'

    setIsValidated(prevState => ({...prevState, [name]: state ? value : null}))
  }

  const updateData = () => {

    const update = () => {

      getLocation(function(latlng){

        fetch('/api/updatePassing200', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: data.id,
            status: isValidated.status,
            startedby: data.startedby, // prevents updating startby
            completedby: data.completedby, // prevents updating completedby
            reviewedby: data.reviewedby, // prevents updating reviewedby
            notes: isValidated.notes,
            sentOutCompany: isValidated.sentOutCompany,
            sentOutDeliverDate: isValidated.sentOutDeliverDate,
            sentOutReceiveDate: isValidated.sentOutReceiveDate,
            by: props.user.username,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
            moistureTaken: isValidated.moistureTaken,
            mcTareNo: isValidated.mcTareNo,
            mcTareWt: isValidated.mcTareWt,
            wetSoilAndTareWt: isValidated.wetSoilAndTareWt,
            drySoilAndTareWt: isValidated.drySoilAndTareWt,
            tareNo: isValidated.tareNo,
            tareWt: isValidated.tareWt,
            totalWt: isValidated.totalWt,
            retainWt: isValidated.retainWt,
            status: isValidated.status,
            notes: isValidated.notes
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + result)
            props.updateOrigin()
            props.updateSample()
            props.savedSample()

            let description = data.phaseid === 'P' ? `${data.location} @ ${data.depth}ft` :`SN ${data.sampleno}, ${data.location}`

            addActivity('lab', data.jobnumber, data.phaseid, '200', 'update', description, props.user.username)

            //this handles status on tbllab..eventually phase out!!

            fetch('/api/updateModalStatus', {
              method: 'post',
              headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: data.labid,
                field: 'status200',
                status: isValidated.status
              })
            })
            .then(res=>res.json())
            .then(
              (result) => {
                //console.log('result: ' + result)
              },
              (error) => {
                alert('Error: could not update status')
                console.log('error: ' + error)
              }
            )

          },
          (error) => {
            alert('Error: could not update test')
            console.log('error: ' + error)
          }
        )

      })

    }

    if (isValidated.status === 'assigned' || isValidated.status === 'started') {
      update()

    } else if (isValidated.status === 'notRun') {

      if (isValidated.notes === '' || isValidated.notes === null) {
        alert('Please add a note.')
      } else {
        update()
      }

    } else if (isValidated.status === 'completed' || isValidated.status === 'reviewed') {

      let d = document
      let description = d.getElementById('sampleDescription').value
      let color = d.getElementById('sampleColor').value

      if (description === '' || description === null) {
        alert('Please provide a description.')
      } else if (color === '' || color === null) {
        alert('Please provide a color.')
      } else if (isValidated.tareNo === '' || isValidated.tareNo === null) {
        alert('Please specify a tare number.')
      } else if (isValidated.tareWt === '' || isValidated.tareWt === null) {
        alert('Please specify a tare weight.')
      } else if (isValidated.totalWt === '' || isValidated.totalWt === null) {
        alert('Please specify a total soil and tare weight.')
      } else if (isValidated.retainWt === '' || isValidated.retainWt === null) {
        alert('Please specify a retained soil and tare weight.')
      } else if (isValidated.moistureTaken) {

        if (isValidated.mcTareNo === '' || isValidated.mcTareNo === null) {
          alert('Please specify a tare number for the moisture.')
        } else if (isValidated.mcTareWt === '' || isValidated.mcTareWt === null) {
          alert('Please specify a tare weight for the moisture.')
        } else if (isValidated.wetSoilAndTareWt === '' || isValidated.wetSoilAndTareWt === null) {
          alert('Please provide a wet soil and tare weight.')
        } else if (isValidated.drySoilAndTareWt === '' || isValidated.drySoilAndTareWt === null) {
          alert('Please provide a dry soil and tare weight.')
        } else {
          update()
        }

      } else {
        update()
      }

    } else {
      alert('Error: unexpected status.')
      console.log('updateSample Status error: ' + isValidated.status)
    }

  }

  const clearMoistureInputs = (event) => {
    let value = event.target.checked

    if (!value) {
      if (window.confirm('Remove moisture if found?')) {

        setIsValidated(prevState => ({...prevState,
          mcTareNo: '',
          mcTareWt: null,
          wetSoilAndTareWt: null,
          drySoilAndTareWt: null
        }))

      } else {
        event.target.checked = true

        // the below code isnt necessary i believe. if cb is set to true, it doesnt change.
        // Therefore onChange doesnt trigger. However this is safer for now

        setIsValidated(prevState => ({...prevState,
          moistureTaken: true
        }))
      }
    }

  }

  //const changedSample = () => setIsChangedSample(true)

  let editSampleIcon = props.user.todo > 1 ?
    <Icon name='check_circle' color={props.isChangedSample ? 'dodgerblue' : 'gray'} id={data.id} onClick={props.isChangedSample ? updateData : nothingChanged} /> :
    null

  let wtOfWater = Number(isValidated.wetSoilAndTareWt) - Number(isValidated.drySoilAndTareWt)
  let wtOfDrySoil = Number(isValidated.drySoilAndTareWt) - Number(isValidated.mcTareWt)
  let moistureContent = Math.round(10*wtOfWater/wtOfDrySoil*100)/10

  let totalWt = isValidated.moistureTaken ? (Number(isValidated.totalWt) - Number(isValidated.tareWt)) / (1 + (moistureContent/100)) : Number(isValidated.totalWt) - Number(isValidated.tareWt)
  let retainWt = Number(isValidated.retainWt) - Number(isValidated.tareWt)

  let retained200 = Math.round(10*(retainWt / totalWt) * 100)/10
  let passed200 = Math.round(10*(100 - retained200))/10

  let moistureInputs = isValidated.moistureTaken ?
  (
    <>
      <label>Tare No
        <input style={{width: 75}} className='input' type="text" pattern="[a-zA-Z0-9 ]{1,}" name='mcTareNo' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.mcTareNo} required />
      </label><br />

      <label>Tare Wt (g)
        <input style={{width: 75}} className='input' type="text" pattern="\d{1,4}(\.\d{1})?" name='mcTareWt' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.mcTareWt} required />
      </label><br />

      <label>Wet Soil and Tare Wt (g)
        <input style={{width: 75}} className='input' type="text" pattern="\d{1,4}(\.\d{1})?" name='wetSoilAndTareWt' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.wetSoilAndTareWt} required />
      </label><br />

      <label>Dry Soil and Tare Wt (g)
        <input style={{width: 75}} className='input' type="text" pattern="\d{1,4}(\.\d{1})?" name='drySoilAndTareWt' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.drySoilAndTareWt} required />
      </label><br />

      <label><b>Moisture Content (%)</b>
        <input style={{width: 75}} className='input' type="text" value={moistureContent} disabled />
      </label><br />
    </>
  ) :
  null

  return (
    <div style={{display: 'inline-block', margin: 10}}>

      <div style={{display: 'inline-block', textAlign: 'right'}}>

        <div style={{borderBottom: '1px solid #d3d3d3', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <h3 style={{display: 'inline-block'}}>Moisture?</h3><input style={{display: 'inline-block', margin: 10, height: 20, width: 20}} type='checkbox' pattern="{1,}" name='moistureTaken' onInput={validate} onChange={props.changedSample} onClick={clearMoistureInputs} defaultChecked={isValidated.moistureTaken} />
        </div>

        {moistureInputs}

        <div style={{borderBottom: '1px solid #d3d3d3', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10}}>

          <h3>200 Wash</h3>

        </div>

        <label>Tare No
          <input style={{width: 75}} className='input' type="text" pattern="[a-zA-Z0-9 ]{1,}" name='tareNo' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.tareNo} required />
        </label><br />

        <label>Tare Wt (g)
          <input style={{width: 75}} className='input' type="text" pattern="\d{1,4}(\.\d{1})?" name='tareWt' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.tareWt} required />
        </label><br />

        <label>Total Soil and Tare Wt (g)
          <input style={{width: 75}} className='input' type="text" pattern="\d{1,4}(\.\d{1})?" name='totalWt' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.totalWt} required />
        </label><br />

        <label>Retained Dry Soil and Tare Wt (g)
          <input style={{width: 75}} className='input' type="text" pattern="\d{1,4}(\.\d{1})?" name='retainWt' onInput={validate} onChange={props.changedSample} defaultValue={isValidated.retainWt} required />
        </label><br />

        <label><b>Retained on 200 (%)</b>
          <input style={{width: 75}} className='input' type="text" value={retained200} disabled />
        </label><br />

        <label><b>Passing the 200 (%)</b>
          <input style={{width: 75}} className='input' type="text" value={passed200} disabled />
        </label><br />

        <div style={{textAlign: 'center', marginTop: 10}}>

          <TestNotes notes={data.notes} onInput={validate} onChange={props.changedSample} />

          <SentOut data={data} onInput={validate} onChange={props.changedSample} />

          <SampleStatus who={props.who} status={data.status} onInput={validate} onChange={props.changedSample} />

          {editSampleIcon}

        </div>

      </div>

    </div>
  )

}

export default Passing200
